import {Language} from '../../i18n/interface/language'

export class ResourceRequest {
    constructor(public languageID: Language,
                public resourceKey: string,
                public text: string,
                public id?: number) {
    }
}